module.exports = __webpack_public_path__ + "img/qrcode.e07c249a.png";